import { Stack, Typography } from '@mui/material';
import { ClickableCard } from './ClickableCard';

type CaptionCardProps = {
  endElement?: React.ReactNode;
  title: string;
  caption: string;
  onClick?: () => void;
  disabled?: boolean;
  disabledMessage?: string;
};

const CaptionCard = (props: CaptionCardProps) => {
  const { endElement, title, caption, onClick, disabled, disabledMessage } = props;

  return (
    <ClickableCard onClick={onClick} disabled={disabled} disabledMessage={disabledMessage}>
      <Stack
        bgcolor="white"
        direction="row"
        spacing={1.5}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack direction="column">
          <Typography variant="h6" color="text.primary" fontSize="14px">
            {title}
          </Typography>
          <Typography variant="caption" color="text.secondary" fontSize="12px">
            {caption}
          </Typography>
        </Stack>
        {endElement}
      </Stack>
    </ClickableCard>
  );
};

export default CaptionCard;
